import { findIndex } from 'lodash'
import { mapGetters, mapState } from 'vuex'

export default {
  filters: {
    prettyKey (val) {
      const keyDict = {
        USER: 'Utilisateur',
        POLE: 'Pole',
        COMPANY: 'Société'
      }
      return keyDict[val]
    }
  },
  props: {
    excludes: {
      type: Array,
      default () {
        return []
      }
    },
    facets: {
      type: Object,
      required: false
    },
    includes: {
      type: Array,
      default: null
    },
    contactSeller: {
      type: String,
      required: false
    },
    mode: {
      type: String,
      default: 'store'// also available : append
    },
    params: Object
  },
  created () {
    if (this.params && this.params.customAlgoliaKey) {
      this.algoliaKeys = this.params.customAlgoliaKey
    }
  },
  data () {
    return {
      algoliaKeys: ['USER', 'COMPANY', 'POLE'],
      entities: [],
      loading: false,
      rawResults: {},
      input: null
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['currentUserName', 'isLog', 'currentUserPk', 'currentCompanyPk', 'isSeller', 'isExternal', 'isAdmin', 'isManager', 'isSectorManager', 'isOperator', 'isEditor']),
    entitiesPk () {
      return this.entities.map(x => {
        return x.pk
      })
    },
    results () {
      let results = []
      Object.values(this.rawResults).forEach(x => {
        let items = x.items.map(y => {
          y.key = x.key
          return y
        })
        results = results.concat(items)
      })
      return results
    }
  },
  methods: {
    reset () {
      this.entities = []
    },
    selectEntity (entity) {
      if (this.mode === 'store') {
        this.entities = [entity]
      } else {
        this.entities.push(entity)
      }
    },
    unselectEntity (entity) {
      if (this.mode === 'store') {
        this.entities = []
      } else {
        let index = findIndex(this.entities, x => {
          return x === entity
        })
        if (index >= 0) {
          this.entities.splice(index, 1)
        }
      }
    },
    submit () {
      this.$emit('submit', {entities: this.entities})
    },
    startSearch () {
      this.loading = true
      let queries = []
      let query = this.input
      let hitsPerPage = 40
      if (this.algoliaKeys.includes('USER') && (this.isAdmin || this.isSectorManager || this.isManager || this.isOperator || (this.isSeller && this.currentUser.manager))) {
        let userQuery = {
          indexName: 'USER',
          query,
          params: {
            hitsPerPage,
            facetFilters: []
          }
        }
        if (this.isExternal) {
          userQuery.params.facetFilters.push('company:' + this.currentCompanyPk)
        }
        if (this.isManager) {
          userQuery.params.facetFilters.push('manager_group:' + this.currentUserPk)
        }
        if (this.facets && 'USER' in this.facets) {
          if (Array.isArray(this.facets.USER)) {
            userQuery.params.facetFilters = userQuery.params.facetFilters.concat(this.facets.USER)
          } else {
            userQuery.params.facetFilters.push(this.facets.USER)
          }
        }
        if (this.isSeller && !this.isManager && this.currentUser.manager) {
          userQuery.params.facetFilters.push('manager_group:' + this.currentUser.manager)
        }
        if (this.isSectorManager) {
          userQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
        }
        queries.push(userQuery)
      }

      if (this.algoliaKeys.includes('COMPANY') && (this.isAdmin || this.isSectorManager)) {
        let companyQuery = {
          indexName: 'COMPANY',
          query,
          params: {
            hitsPerPage,
            facetFilters: []
          }
        }
        if (this.isSectorManager) {
          companyQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
        }
        queries.push(companyQuery)
      }
      if (this.algoliaKeys.includes('POLE') && (this.isAdmin || this.isManager || this.isSeller) && !this.isExternal) {
        let poleQuery = {
          indexName: 'POLE',
          query,
          params: {
            hitsPerPage,
            facetFilters: []
          }
        }

        if (!this.isAdmin) {
          poleQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
        }
        queries.push(poleQuery)
      }

      if (this.algoliaKeys.includes('CONTACT')) {
        let contactQuery = {
          indexName: 'CONTACT',
          query,
          params: {
            hitsPerPage,
            facetFilters: []
          }
        }
        if (this.isSeller) {
          contactQuery.params.facetFilters.push('seller:' + this.currentUserPk)
        } else if (this.contactSeller) {
          contactQuery.params.facetFilters.push('seller:' + this.contactSeller)
        } else if (this.isSectorManager) {
          contactQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
        }

        if (this.isExternal) {
          contactQuery.params.facetFilters.push('company:' + this.currentCompanyPk)
        }
        queries.push(contactQuery)
      }
      this.$algolia.search(queries, (err, res) => {
        if (err) {
          console.log(err)
          this.loading = false
        } else {
          res.results.forEach(x => {
            let key = x.index
            if (x.hits && x.hits.length > 0) {
              this.$set(this.rawResults, key, {
                items: x.hits.filter(hit => {
                  if (this.includes) {
                    return this.excludes.includes(hit.pk) === false && this.includes.includes(hit.pk) === true
                  } else return this.excludes.includes(hit.pk) === false
                }),
                key: key
              })
              this.loading = false
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/EntityMixin.js